export default "__VITE_ASSET__B9xWkeW0__"